import { createBrowserHistory } from 'history'

const historyConfig = {
    basename: '/data/'
};

export default createBrowserHistory(historyConfig)